<app-access-item
  [icon]="'/assets/icons/color-label-filled.svg'"
  [iconColor]="colorLabel().active ? colorLabel().color : 'grey'"
>
  <app-access-item-body>
    <div class="field-content">
      <app-input-field [noLabel]="true" [smallNoLabel]="true" class="headless">
        <input
          type="text"
          [(ngModel)]="labelName"
          (ngModelChange)="updateColorLabelDebounced()"
          [placeholder]="colorLabel().color | capitalize"
          [disabled]="!labelActive() || !('asset:custom-labels' | billingScope)"
        />
      </app-input-field>
      <app-switch [small]="true">
        <input
          type="checkbox"
          id="toggle-color{{ colorLabel().color }}"
          [(ngModel)]="labelActive"
          (ngModelChange)="updateColorLabel()"
          [disabled]="!('asset:custom-labels' | billingScope)"
        />
        <label for="toggle-color{{ colorLabel().color }}"></label>
      </app-switch>
    </div>
  </app-access-item-body>
</app-access-item>
